import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id ED5D1835-D69E-458A-9CCE-F1B81EB831D2
 * name music-note-plus
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-plus.svg
 * tags
 * - Audio 
 * - Music 
 */
export const MusicNotePlusIcon = createSvgIcon(<><path d="M17 9V12H14V14H17V17H19V14H22V12H19V9H17M9 3V13.55C8.41 13.21 7.73 13 7 13C4.79 13 3 14.79 3 17S4.79 21 7 21 11 19.21 11 17V7H15V3H9Z" /></>, 'MusicNotePlusIcon');
export default MusicNotePlusIcon